import { Select } from 'components/Forms'
import { Label } from 'components/Labels'
import { Button } from '@outbound-ai/ursa'

import styled from 'styled-components'

export const SettingsSecurity = () => {
  const twoFactorOptions = [
    {
      value: 'enforced',
      label: 'Enforced',
    },
    {
      value: 'enabled',
      label: 'Enabled',
    },
    {
      value: 'disabled',
      label: 'Disabled',
    },
  ]
  return (
    <Div>
      <h1>
        Security <Label text="Organization" bgColor="primary" />
      </h1>

      <div className="section">
        <div>
          <p>Two-factor Authentication</p>
          <p>Two-factor authentication can be enforced for all users and for specific groups.</p>
        </div>

        <Select name="twoFactorOptions" options={twoFactorOptions} />

        <Button variant="info" radius="rounded">
          Save Changes
        </Button>
      </div>
    </Div>
  )
}

const Div = styled.div``
